import { render, staticRenderFns } from "./Clvideo.vue?vue&type=template&id=8591e006&scoped=true&"
import script from "./Clvideo.vue?vue&type=script&lang=js&"
export * from "./Clvideo.vue?vue&type=script&lang=js&"
import style0 from "./Clvideo.vue?vue&type=style&index=0&id=8591e006&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8591e006",
  null
  
)

export default component.exports